import React from 'react';
import { ChampionsTrophyBanner } from './Banner/Banner';
import { HowToPlay } from './HowToPlay/howToPlay';
import { Faqs } from './Faq/Faq';
import { Footer } from './Footer/Footer';



export const DishKiChampionsTrophy = () => {
    return (
        <>
            <div id='home'>
                <ChampionsTrophyBanner /> 
            </div>
            <div id='howToPlay'>
                <HowToPlay />
            </div>
            <div id='faq'>
                <Faqs />
            </div>
           <Footer />
        </>
    );
}